
import get from 'lodash-es/get';
import React from 'react';

import { useConstants } from '../../../../../hooks/useConstants';
import BaseSize from '../Size';

export default function Size() {
  const { constants } = useConstants();

  const MOMENTS_ACCEPTED_SIZES = get(constants, 'CREATIVE.MOMENTS_ACCEPTED_SIZES', []);

  return(
    <BaseSize fieldName="momentNativeAd.size" options={MOMENTS_ACCEPTED_SIZES} defaultValue="320x480" />
  );
}